import { type HTMLAttributes, type ReactNode } from "react";
import { cn } from "./utils/cn";

export type BannerVariant = "info" | "success" | "warning" | "error";

export interface BannerProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  variant?: BannerVariant;
  title?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}

export const Banner = ({
  variant = "info",
  title,
  actions,
  className,
  children,
  ...rest
}: BannerProps) => (
  <div
    role={variant === "error" ? "alert" : "status"}
    className={cn("hui-banner", `hui-banner--${variant}`, className)}
    {...rest}
  >
    <div className="hui-banner__body">
      {title && <div className="hui-banner__title">{title}</div>}
      {children}
      {actions && <div className="hui-banner__actions">{actions}</div>}
    </div>
  </div>
);
